import { render, staticRenderFns } from "./AwardFilterDefaultLayout.vue?vue&type=template&id=51d32050&scoped=true"
import script from "./AwardFilterDefaultLayout.vue?vue&type=script&lang=js"
export * from "./AwardFilterDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d32050",
  null
  
)

export default component.exports